import { render, staticRenderFns } from "./NewsCarousel.vue?vue&type=template&id=0b6e373c&scoped=true"
import script from "./NewsCarousel.vue?vue&type=script&lang=js"
export * from "./NewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./NewsCarousel.vue?vue&type=style&index=0&id=0b6e373c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6e373c",
  null
  
)

export default component.exports